import C42Theme from '@c42/material-ui-theme';
import { CssBaseline } from '@mui/material';
import React from 'react';
import AuthDataProvider from './auth/AuthDataProvider';
import MainDataProvider from './main/MainDataProvider';
import ResetPasswordDataProvider from './resetPassword/ResetPasswordDataProvider';
import RoutingDataProvider from './routing/RoutingDataProvider';

const AppProviders: React.FC<React.PropsWithChildren<Record<never, unknown>>> = ({ children }) => (
  <C42Theme>
    <CssBaseline>
      <RoutingDataProvider>
        <AuthDataProvider>
          <MainDataProvider>
            <ResetPasswordDataProvider>{children}</ResetPasswordDataProvider>
          </MainDataProvider>
        </AuthDataProvider>
      </RoutingDataProvider>
    </CssBaseline>
  </C42Theme>
);

export default AppProviders;
